import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Field, reduxForm, reset } from 'redux-form';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Button from 'components/buttons/Button';
import Dialog from 'components/modals/Dialog';
import Select from 'components/forms/Select';
import Error from 'components/forms/Error';
import DialogTitle from 'components/modals/DialogTitle';
import { Grid } from '@material-ui/core';
import {
  getOrganizationEmailConfigs,
  addEmailConfig,
  getAccountEmailConfigs,
} from 'redux/actions/emailConfigActions';
import { setAddEmailConfigOpen } from 'redux/actions/campaignActions';
import { resultsToOptions } from 'utils/misc';
import { requiredOptionValidator } from 'utils/validators';
import EmailConfigCreate from './EmailConfigCreate';


class EmailConfigCreatePrompt extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    emailConfigs: PropTypes.shape({
      loading: PropTypes.bool,
      results: PropTypes.array,
    }),
    account: PropTypes.shape({
      loading: PropTypes.bool,
      id: PropTypes.number,
      organization: PropTypes.number,
    }).isRequired,
    getOrganizationEmailConfigs: PropTypes.func.isRequired,
    addEmailConfig: PropTypes.func.isRequired,
    getAccountEmailConfigs: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onEmailCreateSuccess: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    valid: PropTypes.bool,
    openAddEmailConfig: PropTypes.bool,
    setAddEmailConfigOpen: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    emailConfigs: { loading: true, results: [] },
    submitting: false,
    valid: false,
    openAddEmailConfig: false,
    setAddEmailConfigOpen: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.openAddEmailConfig,
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.props.getOrganizationEmailConfigs(this.props.account.organization);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.openAddEmailConfig !== this.props.openAddEmailConfig) {
      this.setState({ isOpen: nextProps.openAddEmailConfig });
    }
  }

  getOptions() {
    const emailConfigs = this.props.emailConfigs.results.filter(emailConfig => (
      !emailConfig.accounts.includes(this.props.account.id)
    ));
    return resultsToOptions(emailConfigs, 'email', 'id') || [];
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    }, () => {
      if (!this.state.isOpen) {
        this.props.dispatch(reset('EmailConfigCreatePrompt-form'));
        if (this.props.openAddEmailConfig) this.props.setAddEmailConfigOpen(false);
      }
    });
  }

  handleSubmit = async (formData) => {
    const data = {
      email_config: formData.sendingEmail.value,
      accounts: [this.props.account.id],
    };
    await this.props.addEmailConfig(
      this.props.account.organization,
      data,
    );
    await this.props.getAccountEmailConfigs(this.props.account.id);
    this.toggle();
    this.props.onEmailCreateSuccess(formData.sendingEmail.label);
  }

  render() {
    const { submitting, valid, handleSubmit } = this.props;
    return (
      <div className={this.props.className}>
        <Button
          className="mb-2 mt-3"
          variant="textPrimaryContained"
          onClick={this.toggle}
          size="large"
          data-intercom-target="Add email config button"
        >
          Add email
        </Button>
        <Dialog
          open={this.state.isOpen}
          onBackdropClick={this.toggle}
          size="small"
        >
          <DialogTitle id="dialog-title" className="mb-1" disableTypography>
            Sending Email Addresses
          </DialogTitle>
          <div className="text-center small mb-2">
            Select sending email for this account from connected  email addresses or create new.
          </div>
          <form className="instance-form" onSubmit={handleSubmit(this.handleSubmit)}>
            <div className="instance-form__body">
              {/* eslint-disable jsx-a11y/label-has-for */}
              <label>Sending email</label>
              <Field
                name="sendingEmail"
                validate={[requiredOptionValidator]}
                component={propsCus => (
                  <React.Fragment>
                    <Select
                      placeholder="Type to find and select sending email..."
                      isLoading={this.props.emailConfigs.loading}
                      value={propsCus.input.value}
                      onChange={propsCus.input.onChange}
                      onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
                      options={this.getOptions()}
                    />
                    {propsCus.meta.touched &&
                      propsCus.meta.error && <Error error={propsCus.meta.error} />}
                  </React.Fragment>
                )}
              />
            </div>
            <div className="instance-form__footer mt-2">
              <Grid container spacing={1}>
                <Grid item sm={6}>
                  <EmailConfigCreate
                    accountId={this.props.account.id}
                    organizationId={this.props.account.organization}
                    className="float-right"
                    onEmailCreateSuccess={this.props.onEmailCreateSuccess}
                  />
                </Grid>
                <Grid item sm={6}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={!valid || submitting}
                    fullWidth
                  >
                    Select
                  </Button>
                </Grid>
              </Grid>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      account: state.account,
      emailConfigs: state.organizationEmailConfigs,
      config: state.config,
      openAddEmailConfig: state.createCampaignState.openAddEmailConfig,
      initialValues: {
        sendingEmail: null,
      },
    }),
    {
      getOrganizationEmailConfigs,
      addEmailConfig,
      getAccountEmailConfigs,
      setAddEmailConfigOpen,
    },
  ),
  withNamespaces('common'),
  reduxForm({ form: 'EmailConfigCreatePrompt-form', destroyOnUnmount: true }),
)(EmailConfigCreatePrompt);
